module.exports = __webpack_public_path__ + "img/485-687d58.png";